// extracted by mini-css-extract-plugin
export default {"wrapper":"EquipmentProductPlan_wrapper__KVSnu"};